module.exports = __webpack_public_path__ + "img/img_liucheng.e3286eec.jpg";